<template>
    <div class="hello">
        <div class="top_infor">
            <div class="col-3">
                <p v-for="item in label1">
                    <span class="label">{{item.name}}</span>
                    <span class="content">{{data[item.key]?data[item.key]:'--'}}</span>
                </p>
            </div>
            <div class="col-3">
                <p v-for="item in label2">
                    <span class="label">{{item.name}}</span>
                    <span class="content">{{data[item.key]?data[item.key]:'--'}}</span>
                </p>
            </div>
            <div class="col-3">
                <div>
                    <img :src="data.avatar?data.avatar:headerImg" alt="" style="width: 160px;">
                    <p style="text-align:center;width: 160px;">头像</p>
                </div>
                <div v-if="$route.query.roleCode=='individualAgent'">
                    <img :src="data.zhiyeImg?data.zhiyeImg:headerImg" alt="" style="width: 160px;">
                    <p style="text-align:center;width: 160px;">执业证</p>
                </div>   
            </div>
        </div>
        <div style="padding-left:120px;">
            <button @click="modal1=true;" style="background-color:#bb1b1b;width:100px;height:40px;border-radius:5px;color:#fff;">注销帐号</button>
        </div> 
        <div class="evaluate_class" v-if="$route.query.roleCode=='yuejuAgent'">
            <div>
                    <Table stripe :columns="columns1" :data="data1" disabled-hover :no-data-text="'暂无数据'"></Table>
            </div>
        </div>
        <Modal
            v-model="modal1"
            title="提示!"
            @on-ok="ok"
            @on-cancel="cancel">
            <p>帐号注销后无法找回，是否继续注销？</p>
        </Modal>
    </div>
</template>

<script>
import yellowstar from '@/assets/img/yellowstar.png'
import graystar from '@/assets/img/graystar.png'
import headerImg from '@/assets/img/personimg.png'
import {admin} from '@/api/admin'
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    },
    data(){
        return{
            modal1:false,
            headerImg:headerImg,
            yjjjr:true,
            data:{
            },
            columns1: [
                    {
                        title: '日期',
                        align:'center',
                        key: 'evaluateTime'
                    },
                    {
                        title: '评价类型',
                        align:'center',
                        key: 'evaluateTypeText'
                    },
                    {
                        title: '评语',
                        align:'center',
                        key: 'evaluateContent'
                    },
                    {
                        title: '服务态度',
                        align:'center',
                        key: 'statue',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {domProps:{
                                    innerHTML:`<span style="width:90px;background:url(`+graystar+`);display:inline-block;height:18px;vertical-align: top;margin-right:10px;position:relative;"><span style="height:18px;position:absolute;top:0;left:0;width:`+(+params.row.serviceAttitude)/5*90+`px;background:url(`+yellowstar+`);"></span></span>`//渲染html内容
                                }}),
                                h('span', {
                                    props: {
                                        type: 'text'
                                    },
                                }, params.row.serviceAttitude+'分')
                            ])
                        }        
                    },
                    {
                        title: '专业水平',
                        align:'center',
                        key: 'statue',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {domProps:{
                                    innerHTML:`<span style="width:90px;background:url(`+graystar+`);display:inline-block;height:18px;vertical-align: top;margin-right:10px;position:relative;"><span style="height:18px;position:absolute;top:0;left:0;width:`+(+params.row.professionalLevel)/5*90+`px;background:url(`+yellowstar+`);"></span></span>`//渲染html内容
                                }}),
                                h('span', {
                                    props: {
                                        type: 'text'
                                    },
                                }, params.row.professionalLevel+'分')
                            ])
                        } 
                    }
                ],
                data1: [
                    // {
                    //     num: '2013-01-01',
                    //     type: '带看评价',
                    //     txt: '态度蛮横，水平不高。',
                    //     statuesscore:'5',
                    // },
                    // {
                    //     num: '2013-01-01',
                    //     type: '带看评价',
                    //     txt: '态度蛮横，水平不高。',
                    //     statuesscore:'3'
                    // },
                ]
            
        }
    },
    computed:{
        label1(){
            if(this.$route.query.roleCode=='individualAgent'){
                return[
                    {name:'姓名',key:'realname'},
                    {name:'性别',key:'sex'},
                    {name:'联系电话',key:'phone'},
                    {name:'从业年限',key:'congyeNum'},
                    {name:'通讯地址',key:'address'},
                    {name:'帐号',key:'userName'},
                    {name:'执业证号',key:'zhiyeNum'},
                    {name:'证书有效期',key:'certificateExpirationTime'},
                    {name:'角色',key:'roleName'},
                ]
            }
            if(this.yjjjr){
                return[
                    {name:'姓名',key:'realname'},
                    {name:'性别',key:'sex'},
                    {name:'联系电话',key:'phone'},
                    {name:'从业编号',key:'congyeNum'},
                    {name:'执业证号',key:'zhiyeNum'},
                    {name:'证书有效期',key:'certificateExpirationTime'},
                    {name:'帐号',key:'userName'},
                    {name:'从业机构',key:'companyName'},
                    {name:'归属门店',key:'storeName'},
                    {name:'角色',key:'roleName'},
                ]
            }else{
                return [
                    {name:'姓名',key:'realname'},
                    {name:'性别',key:'sex'},
                    {name:'联系电话',key:'phone'},
                    {name:'角色',key:'roleName'},
                    
                ]
            }
        },
        label2(){
            if(this.$route.query.roleCode=='individualAgent'){
                return[]
            }
            if(this.yjjjr){
                return[
                   {name:'实勘的房源数',key:'shikan'},
                    {name:'发布的房源数',key:'fabu'},
                    {name:'维护的客源数',key:'weihuky'},
                    {name:'客源跟进次数',key:'genjinky'},
                    {name:'带看次数',key:'daikan'},
                    {name:'房源跟进次数',key:'genjinfy'},
                    {name:'成交的房源数',key:'sale'},
                    {name:'租出的房源数',key:'rent'},
                    {name:'评价率',key:'evaluationRate'},
                    {name:'评分',key:'score'},
                ]
            }else{
                return [
                    {name:'帐号',key:'userName'},
                    {name:'从业机构',key:'companyName'},
                    {name:'归属门店',key:'storeName'},
                ]
            }
        }
    },
    mounted(){
        if(this.$route.query.roleCode!='yuejuAgent'){
            this.yjjjr=false;
        }else{
            this.getaccountEvaluate();
        }
        this.getinfor();
        
    },
    methods:{
        ok(){
            this.deleteUser();
        },
        cancel(){

        },
        deleteUser(){
                admin.deleteAdmin({id:this.$route.query.id}).then(res=>{
                    if(res.data.success){
                        this.$router.go(-1);
                    }else{
                        this.$Message.error(res.data.message);
                    }
            })
        },
        getinfor(){
            admin.getaccountInfor(this.$route.query.id).then(res=>{
                if(res.data.success){
                    for(var k in res.data.result){
                        if(k=='certificateExpirationTime' && res.data.result[k]){
                           res.data.result[k] = res.data.result[k].split(' ')[0];
                        }
                    }
                    this.data=res.data.result;
                }
            })
        },
        getaccountEvaluate(){
            admin.getaccountEvaluate(this.$route.query.id).then(res=>{
                if(res.data.success){
                    this.data.evaluationRate=res.data.result.evaluationRate;
                    this.data.score=res.data.result.score;
//                     res.data.result.userEvaluationVO=[{
//         "evaluateId": "1111111",
//         "evaluateTime": "2019-10-10",
//         "evaluateType": "评价类型",
//         "evaluateTypeText": "评价类型文字",
//         "evaluateContent": "评价内容",
//         "serviceAttitude": "3",
//         "professionalLevel": "4"
//     }
// ];
                    this.data1=res.data.result.userEvaluationVO;
                }
            })
        }
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .top_infor{
      padding-top: 105px;  
    }
    .col-3{
        display: inline-block;
        width: 33%;
        box-sizing: border-box;
        padding-left: 120px;
        vertical-align: top;
    }
    .col-3 p{
        margin-bottom: 40px;
    }
    .label{
        font-size: 14px;
        color: #101d37;
        display: inline-block;
        width: 100px;
        margin-right:10px;
    }
    .evaluate_class{
        margin-top:40px;
    }
</style>
